import React from "react";
import { useParams } from "react-router-dom";
import { courses } from "../assets/data/data2";

import {
  Breadcrumb,
  DetailCurriculum,
  DetailAside,
  DetailDescription,
  DetailHeader,
  DetailInstructor,
  DetailReviews,
  DetailTabs,
} from "../components";

import { course } from "../assets/data/data";


const {
  info,
  details,
  chapters,
  description,
  creator,
  coments,
  rating,
} = course;

const SingleCourse = () => {

  const { courseId } = useParams();
  let currentData = courses[courseId];

  return (
    <>
      <Breadcrumb courses current={currentData.info.title} />
      <section className="single-course mb-5">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4 order-lg-last ">
              <DetailAside {...currentData.details} />
            </div>
            <div className="col-lg-8">
              <div className="course-main">
                <div className="main-header">
                  <DetailHeader {...currentData.info} />
                </div>
                <div className="main-tabs my-4">
                  <DetailTabs />
                </div>
                <div className="main-tab-content box">
                  <div className="tab-content" id="nav-tabContent">
                    {/* course-curriculum start */}
                    
                    <DetailDescription {...currentData.description} />
                    {/* course-description end */}
                    {/* course-instructor start */}
                    <DetailInstructor {...currentData.creator} />
                    {/* course-instructor end */}
                    {/* course-reviews start */}
                    <DetailReviews coments={coments} rating={rating} />
                    {/* course-reviews end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SingleCourse;
